import { Button, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useMutation, useQueryClient } from 'react-query';
import { GetPrePaymentGatewayResult } from '../../../services/payment.service';
import PaymentReceiptSkeleton from '../../../pages/requestSteps/inquiryFee/resultPayment/paymentReceiptSkeleton';
import EmptyPageStyle from '../../../pages/emptyPageStyle/emptyPageStyle';
import { useAuth } from '../../../config/AuthProvider/authProvider';
import { v4 as uuid } from "uuid";
import { IContainerApp } from '../../../pages/navigationButtonComponents/loansTab/containerApp/IContainerApp';

function OnlinePrePaymentReceipt({ setStep }: IContainerApp) {

    const [data, setData] = useState<any>();
    const [isData, SetIsData] = useState<boolean>(false);
    const { referenceKey, setRefKey } = useAuth();
    const queryClient = useQueryClient();


    const { mutate: GetPrePaymentGatewayResultMutation, isLoading, isError } =
        useMutation(GetPrePaymentGatewayResult, {
            onSuccess: (data) => {
                if (data.isSuccess) {
                    setData(data.data)
                    SetIsData(false)
                    setRefKey(data.data.referenceKey)
                    queryClient.setQueryData('ONLINE_PREPAYMENT', '')

                }
                else {
                    SetIsData(true)
                }
            }
        });
    const myUrl = queryClient.getQueryData("URL_PARAMS") as any
    useEffect(() => {
        const token = myUrl?.token;
        GetPrePaymentGatewayResultMutation({ gatewayPaymentToken: token?.get('t'), referenceKey: referenceKey! });
        queryClient.setQueryData("URL_PARAMS", '')
    }, [])
    if (isLoading || (!data && !isData && !isError)) {
        return <PaymentReceiptSkeleton />
    }
    if (isData || isError) {
        return <EmptyPageStyle prefixText="رسید پرداختی" highlightedText=" یافت" suffixText="نشد" />
    }
    const handleClick = () => {
        setStep(uuid())
        // dispatch(getNextInnerState({ nextInnerState: `FutureLoans` }));
    }
    return (
        <>
            <div
                style={{
                    background: 'none',
                    border: 'none !important',
                    position: 'relative',
                    width: '100%',
                    maxWidth: '600px',
                    margin: 'auto',
                    backgroundImage: `url(/images/PaymentReceipt.png)`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '100% 100%',
                    backgroundPosition: 'top center',
                    height: '370px',
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    color: '#212121',

                }}
            >
                <Grid container spacing={2} justifyContent="center ">
                    <Grid item xs={12} textAlign="center" className="  !mt-7">
                        <div style={{ fontSize: '1.2rem' }}  >{data?.amount?.toLocaleString('fa')} ریال</div>
                        {data?.paymentStatus === 'Verified' ? <div className="bgSecondaryColorLight badge mt-4 mb-6">
                            <CheckCircleIcon />
                            &nbsp;پرداخت موفق
                        </div> : <div className=" badge mt-4 mb-6" style={{ background: '#FF617C' }}>
                            <CancelIcon />
                            &nbsp;پرداخت ناموفق
                        </div>}

                    </Grid>

                    <Grid item xs={12}>
                        <hr className="indented-hr" />
                    </Grid>

                    <Grid container item xs={12} className="!mx-6" textAlign="center">

                        <Grid container xs={12} className="mt-2" >
                            {data?.trackingNumber && <><Grid item xs={6} textAlign="right" className="!mt-4 ">شماره پیگیری:</Grid><Grid item xs={6} textAlign="left" className="!mt-4">{data?.trackingNumber}</Grid></>}
                            {data?.paymentDatePersian && <><Grid item xs={6} textAlign="right" className="!mt-4 ">تاریخ و زمان پرداخت:</Grid><Grid item xs={6} textAlign="left" className="!mt-4">{data?.paymentDatePersian}</Grid></>}
                            <Grid item xs={6} textAlign="right" className="!mt-4 ">  درگاه پرداخت:</Grid>
                            <Grid item xs={6} textAlign="left" className="!mt-4 ">{data?.gateway} </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </div>

            <Button
                fullWidth
                onClick={handleClick}
                disabled={false}
                sx={{
                    marginTop: "50px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center", height: "42px",
                    paddingInline: "1rem",
                    backgroundColor: 'var(--button-color) !important',
                    color: 'var(--bg-color) !important',
                    opacity: 1
                }}>
                <Typography marginX={"8px"} >
                    ادامه
                </Typography>

            </Button>
        </>
    )
}

export default OnlinePrePaymentReceipt